import eventHelpers from 'utils/eventHelpers';
import DOMHelper from 'utils/DOMHelpers';

/**
 * @module Header
 */
class Header {
    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._placeholder = this._createPlaceholderElement();
        this._windowWidth = window.innerWidth;
        this._stickyActive = false;
        this._onScrollRaf = eventHelpers.raf(this._onScroll.bind(this));

        this.load();
    }


    /**
     * Base optionss
     */
    static get options() {
        return {
            classnameSticky: 'header--sticky',
            classnamePlaceholder: 'header-placeholder'
        };
    }


    /**
     * Construct module
     */
    load() {
        window.addEventListener('scroll', this._onScrollRaf, { passive: true });
        window.addEventListener('resize', this._onResize.bind(this));
        this._recalculate();
        this._toggle();
    }


    /**
     * Handle window resize event
     * @private
     */
    _onResize() {
        if (window.innerWidth !== this._windowWidth) {
            this._windowWidth = window.innerWidth;
            this._deactivateSticky();
            this._recalculate();
            this._toggle();
        }
    }


    /**
     * On windows scroll event
     * @private
     */
    _onScroll() {
        this._toggle();
    }


    /**
     * Recalculate variables
     * @private
     */
    _recalculate() {
        this._scrollOffsetTop = this._element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    }


    /**
     * Toggle the state of the sticky header
     * @private
     */
    _toggle() {
        if (DOMHelper.getScrollPosition(window) > this._scrollOffsetTop) {
            if (!this._stickyActive) {
                this._activateSticky();
            }
        } else if (this._stickyActive) {
            this._deactivateSticky();
        }
    }


    /**
     * Activate the sticky header
     * @private
     */
    _activateSticky() {
        this._element.classList.add(this._options.classnameSticky);
        this._placeholder.style.height = `${this._element.offsetHeight}px`;
        this._stickyActive = true;
    }


    /**
     * Deactivate the sticky header
     * @private
     */
    _deactivateSticky() {
        this._element.classList.remove(this._options.classnameSticky);
        this._placeholder.style.height = '';
        this._stickyActive = false;

    }


    /**
     * Create the header placeholder
     * @return {Element} the placeholder DOM element
     * @private
     */
    _createPlaceholderElement() {
        const placeholder = document.createElement('div');
        placeholder.className = this._options.classnamePlaceholder;

        this._element.parentNode.insertBefore(placeholder, this._element.nextSibling);

        return placeholder;
    }
}

// Exports
export default Header;
